import { Button, Form, Row, Col } from 'react-bootstrap'
import '../css/client/viewclient.css'
import { MdClose, MdPerson, MdPhone, MdLocationOn, MdFingerprint } from 'react-icons/md'
import { useContext, useEffect, useState } from 'react'
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { Dimcontext } from '../../context/pagecontext'
import { Datacontext } from '../../context/dataContext'

export const Viewclient = ({ set_view, id }) => {
    const { setDim } = useContext(Dimcontext)
    const { clients } = useContext(Datacontext)
    const [client_view, set_client_view] = useState(null);

    useEffect(() => {
        const viewoneClient = () => {
                const data = clients.find(item => item.id === id);
                set_client_view(data);
        };
        viewoneClient()
    }, [id,clients])

    const handleviewclose = () => {
        set_view(false)
        setDim(false)
    }

    const TitleCase = (str) => {
        return str ? str.toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : "—";
    };

    return (
        <div className="view-modal-container">
            {/* Modal Header */}
            <div className='view-modal-header'>
                <div className="d-flex align-items-center gap-2">
                    <div className="brand-dot"></div>
                    <h3 className='m-0'>Profile Information</h3>
                </div>
                <button onClick={handleviewclose} className='modal-close-btn'><MdClose /></button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(90vh - 130px)' }}>
                <div className="view-modal-body">
                    {client_view ? (
                        <Row className="g-4">
                            {/* CID Banner */}
                            <Col xs={12}>
                                <div className="id-badge">
                                    <MdFingerprint size={20} />
                                    <span>Client  ID <strong>{client_view.cid || "N/A"}</strong></span>
                                </div>
                            </Col>

                            {/* Personal Info Section */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="view-label"><MdPerson className="me-1"/> Full Name</Form.Label>
                                    <div className="view-data-box">{TitleCase(client_view.name)}</div>
                                </Form.Group>
                            </Col>

                            {/* Added Nick Name */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="view-label">Nick Name</Form.Label>
                                    <div className="view-data-box">{TitleCase(client_view.nick_name) || "—"}</div>
                                </Form.Group>
                            </Col>

                            {/* Added Role */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="view-label">Client / Broker</Form.Label>
                                    <div className="view-data-box fw-bold text-primary">{TitleCase(client_view.role) || "—"}</div>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="view-label">Gender</Form.Label>
                                    <div className="view-data-box">{TitleCase(client_view.gender)}</div>
                                </Form.Group>
                            </Col>

                            {/* Contact Section */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="view-label"><MdPhone className="me-1"/> Mobile Number</Form.Label>
                                    <div className="view-data-box">{client_view.mobile || "—"}</div>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="view-label"><MdPhone className="me-1"/> Alternate Mobile</Form.Label>
                                    <div className="view-data-box">{client_view.alt_mobile || "—"}</div>
                                </Form.Group>
                            </Col>

                            {/* Location Section */}
                            <Col md={12}>
                                <hr className="my-2 opacity-10" />
                                <h5 className="section-title"><MdLocationOn /> Location Details</h5>
                            </Col>

                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label className="view-label">Address</Form.Label>
                                    <div className="view-data-box address-box">{TitleCase(client_view.address)}</div>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="view-label">District</Form.Label>
                                    <div className="view-data-box">{TitleCase(client_view.city)}</div>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="view-label">State</Form.Label>
                                    <div className="view-data-box">{TitleCase(client_view.state)}</div>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="view-label">Pincode</Form.Label>
                                    <div className="view-data-box">{client_view.pincode || "—"}</div>
                                </Form.Group>
                            </Col>
                        </Row>
                    ) : (
                        <div className="text-center p-5 text-muted">Loading details...</div>
                    )}
                </div>
            </SimpleBar>

            {/* Modal Footer */}
            <div className="view-modal-footer">
                <Button onClick={handleviewclose} className="btn-close-final">Close Window</Button>
            </div>
        </div>
    )
}